import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Chart of accounts" hint="ChartOfAccount from the finance engine." /> }
